import { Link } from "react-router-dom";
import { categories } from "@/mocks/home";

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            浏览分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            选择你感兴趣的内容分类，快速找到想看的影视
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-200/70 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-foreground-700 group-hover:text-primary-600`}></i>
              </div>
              <div className="text-center">
                <p className="font-medium text-foreground-800 group-hover:text-primary-700 text-sm md:text-base whitespace-nowrap">
                  {cat.name}
                </p>
                <p className="text-xs text-foreground-400 mt-1">{cat.count}部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}